'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var Operation = require('../../../types/Operation.cjs');

// -----------------
// Operation
// -----------------

const Key = 'GetBuyerBalanceOperation';

/**
 * Gets the balance of a buyer's escrow account for a given Auction House.
 *
 * ```ts
 * await metaplex
 *   .auctionHouse()
 *   .getBuyerBalance({ auctionHouse, buyerAddress };
 * ```
 *
 * @group Operations
 * @category Constructors
 */
const getBuyerBalanceOperation = Operation.useOperation(Key);

/**
 * @group Operations
 * @category Types
 */

/**
 * @group Operations
 * @category Handlers
 */
const getBuyerBalanceOperationHandler = {
  handle: async (operation, metaplex, scope) => {
    const {
      auctionHouse,
      buyerAddress
    } = operation.input;
    const buyerEscrow = metaplex.auctionHouse().pdas().buyerEscrow({
      auctionHouse,
      buyer: buyerAddress,
      programs: scope.programs
    });
    return metaplex.rpc().getBalance(buyerEscrow, scope.commitment);
  }
};

exports.getBuyerBalanceOperation = getBuyerBalanceOperation;
exports.getBuyerBalanceOperationHandler = getBuyerBalanceOperationHandler;
//# sourceMappingURL=getBuyerBalance.cjs.map
